export function isInitialised(state, path, location) {
  if (state.initialization !== undefined && state.initialization[path]) {
    return state.initialization[path][location];
  }

  return false;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/firekit/es/store/initialization/selectors.js
// module id = 104
// module chunks = 49